import { FETCH_CATEGORIES, LOADING_SET } from "../actions/actionType";

const initialState = {
	categories: [],
	loading: false,
};

export default function categoryReducers(state = initialState, action) {
	switch (action.type) {
		case FETCH_CATEGORIES:
			return {
				...state,
				categories: action.payload,
			};
		case LOADING_SET:
			return {
				...state,
				loading: action.payload,
			};
		default:
			return {
				...state,
			};
	}
}
